@if (loading?.value == false) {
  <section>
    @if (flowHistory.length) {
      @for (entry of flowHistory; track entry; let isLast = $last) {
        <div class="history">
          <history-item [item]="entry"></history-item>
          @if (!isLast) {
            <div class="cell small-12">
              <hr>
              </div>
            }
          </div>
        }
      } @else {
        <p>There is currently no history.</p>
      }
    </section>
  }
  @if (loading?.value == true) {
    <section>
      <text-loader [run]="loading?.value" [interval]="1000" [text]="'Loading Timeline'" [tickType]="'.'"></text-loader>
    </section>
  }

